"use client"

import { useEffect, useState } from "react"
import Layout from "../Layout/Layout"
import "./Analysis.css"
import { useLocation } from "react-router-dom"

const Analysis = () => {
  const [analysisData, setAnalysisData] = useState(null)
  const location = useLocation()

  useEffect(() => {
    const data = location.state?.data
    if (data) {
      console.log("Received analysis data:", data) // Debug log
      setAnalysisData(data)
    } else {
      console.warn("No analysis data found in location.state")
    }
  }, [location.state])

  const getStatusBadge = (status) => {
    const statusClass = `status-badge status-${status.toLowerCase()}`
    return (
      <span className={statusClass}>
        <span className="status-indicator">●</span>
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </span>
    )
  }

  const renderProfessionalList = (items, type = "default") => {
    if (!items || items.length === 0) {
      return <p className="section-content">No data available</p>
    }

    const getItemClass = () => {
      switch (type) {
        case "risk":
          return "list-item risk-item"
        case "recommendation":
          return "list-item recommendation-item"
        default:
          return "list-item"
      }
    }

    return (
      <ul className="professional-list">
        {items.map((item, idx) => (
          <li key={idx} className={getItemClass()}>
            <div className="list-item-number">{idx + 1}</div>
            <div className="list-item-content">{item}</div>
          </li>
        ))}
      </ul>
    )
  }

  const renderKeyValuePairs = (data) => {
    if (!data || Object.keys(data).length === 0) {
      return <p className="section-content">No data available</p>
    }

    return (
      <div className="key-value-grid">
        {Object.entries(data).map(([key, value], idx) => (
          <div key={idx} className="key-value-item">
            <div className="key-value-key">{key}</div>
            <div className="key-value-value">{value}</div>
          </div>
        ))}
      </div>
    )
  }

  const SectionCard = ({ title, children, icon, fullWidth = false }) => (
    <div className="section-card">
      <div className="section-header">
        {icon && <div className="section-icon">{icon}</div>}
        <h2 className="section-title">{title}</h2>
      </div>
      <div className="section-content">{children}</div>
    </div>
  )

  if (!analysisData) {
    return (
      <Layout>
        <div className="analysis-container">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p className="loading-text">Loading analysis data...</p>
          </div>
        </div>
      </Layout>
    )
  }

  const { fileUrl, analysis, paymentStatus, createdAt } = analysisData

  return (
    <Layout>
      <div className="analysis-container">
        {/* Professional Header */}
        <div className="analysis-header">
          <div className="analysis-header-content">
            <h1 className="page-title">Contract Analysis Report</h1>
            <div className="document-info">
              <div className="info-item">
                <div className="info-label">Document</div>
                <div className="filename">{fileUrl ? fileUrl.split("/").pop() : "Unknown Document"}</div>
              </div>
              <div className="info-item">
                <div className="info-label">Payment Status</div>
                {getStatusBadge(paymentStatus || "Unknown")}
              </div>
              <div className="info-item">
                <div className="info-label">Analysis Date</div>
                <div className="analysis-date">
                  {createdAt ? new Date(createdAt).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  }) : "Unknown Date"}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contract Overview - Full Width */}
        <div className="analysis-grid full-width">
          <SectionCard title="Executive Summary" icon="📋">
            <div className="overview-text">{analysis?.["Contract Overview"] || "No overview available"}</div>
          </SectionCard>
        </div>

        {/* Main Analysis Grid */}
        <div className="analysis-grid">
          {/* Key Obligations */}
          <SectionCard title="Key Obligations" icon="✅">
            {renderProfessionalList(analysis?.["Key Obligations"])}
          </SectionCard>

          {/* Milestones */}
          <SectionCard title="Project Milestones" icon="🎯">
            {renderKeyValuePairs(analysis?.["Milestones"])}
          </SectionCard>
        </div>

        {/* Key Sections - Full Width */}
        <div className="analysis-grid full-width">
          <SectionCard title="Critical Contract Sections" icon="📄">
            {renderKeyValuePairs(analysis?.["Key Sections"])}
          </SectionCard>
        </div>

        {/* Risk and Recommendations Grid */}
        <div className="analysis-grid">
          {/* Risk Summary */}
          <SectionCard title="Risk Assessment" icon="⚠️">
            {renderProfessionalList(analysis?.["Risk Summary"], "risk")}
          </SectionCard>

          {/* Actionable Recommendations */}
          <SectionCard title="Strategic Recommendations" icon="💡">
            {renderProfessionalList(analysis?.["Actionable Recommendations"], "recommendation")}
          </SectionCard>
        </div>

        {/* Action Buttons */}
        {/* <div className="action-buttons">
          <button className="action-button action-button-primary">
            <span>📊</span>
            Export Report
          </button>
          <button className="action-button action-button-secondary">
            <span>📄</span>
            View Original Document
          </button>
          <button className="action-button action-button-secondary">
            <span>🖨️</span>
            Print Analysis
          </button>
        </div> */}
      </div>
    </Layout>
  )
}

export default Analysis